// src/runtimeConfig.js
export async function loadRuntimeConfig() {
  const res = await fetch("/runtime-env.js")
  const cfg = await res.json()
  return cfg
}
